import React from 'react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { BONUS_TOTAL, OFFER_ANCHOR, PRICE, PRODUCT_NAME } from '../data/content';
export function FinalCTA() {
  return <section aria-labelledby="cierre" className="bg-navy" data-id="element-57" data-mp="c70xva6rjfok">
      <div className="mx-auto max-w-xl px-3 py-5 text-center sm:px-5" data-id="element-58" data-mp="c4fuggqtgrop">
        <h2 id="cierre" className="font-display text-[1.5rem] font-extrabold leading-none tracking-tight text-ice sm:text-4xl" data-id="element-59" data-mp="83m7pqp41ixe">
          Una última oportunidad
        </h2>
        <p className="mx-auto mt-2 max-w-xl text-sm leading-snug text-white/90" data-id="element-60" data-mp="h5lnkfoe2gyr">
          Puedes seguir guardando videos sobre compresores, refrigerantes,
          manifold, sensores y reparaciones sin saber qué deberías aprender
          primero. O puedes comenzar hoy a construir una nueva habilidad
          siguiendo una ruta organizada desde cero.
        </p>
        <p className="mx-auto mt-1.5 max-w-xl font-sub text-sm font-semibold leading-snug text-white" data-id="element-61" data-mp="zxegyb7de470">
          No necesitas ser experto en aire acondicionado automotriz para
          empezar.{' '}
          <span className="text-ice" data-id="element-62" data-mp="2h4ssiow2a5xh">Necesitas dar el primer paso.</span>
        </p>

        <Reveal className="mt-3 rounded-2xl border-4 border-dashed border-cta bg-white p-3 text-navy" data-id="element-63" data-mp="2m2b0abycef3w">
          <p className="font-display text-sm font-extrabold uppercase leading-tight text-brand" data-id="element-64" data-mp="2r277sl690oo7">
            {PRODUCT_NAME}
          </p>
          <p className="mt-0.5 font-display text-2xl font-extrabold leading-none" data-id="element-65" data-mp="2v38y2ci6tqe1">
            6 Tomos + 5 Bonos
          </p>
          <p className="mt-1 text-xs font-semibold text-slate-600 sm:text-sm" data-id="element-66" data-mp="34tc0127aeeoi">
            Valor de los bonos:{' '}
            <span className="line-through decoration-2" data-id="element-67" data-mp="39s5byq6xdxmk">{BONUS_TOTAL}</span>
          </p>
          <p className="mt-1 font-display text-5xl font-black leading-none text-cta sm:text-6xl" data-id="element-68" data-mp="3erhxn7m28ynk">
            <span className="text-2xl text-navy sm:text-3xl" data-id="element-69" data-mp="3it3c2xe8tkzv">Hoy:</span>{' '}
            {PRICE}
          </p>

          <CtaButton href={OFFER_ANCHOR} size="lg" className="mt-3" data-id="element-70" data-mp="1jntrdtdl5xxt">
            🚀 Sí, quiero comenzar ahora
          </CtaButton>

          <p className="mt-2.5 text-xs font-semibold text-slate-600" data-id="element-71" data-mp="1eqjrtkwhg5w9">
            Acceso Inmediato • Entrega Digital • Garantía de 7 Días
          </p>
        </Reveal>
      </div>
    </section>;
}